import { MdInfoOutline } from "react-icons/md";
import IconButton from "./IconButton";
import Icon from "./Icon";
import { trackUIButtonClick } from "@/utils/analytics";
import { useTranslation } from "react-i18next";

type InformationButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  label?: string;
};

const InformationButton: React.FC<InformationButtonProps> = ({
  className = "",
  onClick,
  label,
  ...rest
}) => {
  const { t } = useTranslation();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    trackUIButtonClick("information");
    onClick?.(event);
  };

  if (label) {
    return (
      <button
        className={`flex items-center gap-1 cursor-pointer bg-transparent border-0 ${className}`}
        onClick={handleClick}
        {...rest}
      >
        <Icon icon={MdInfoOutline} size={16} color="currentColor" />
        <span className="text-[13px] font-normal leading-none">{label}</span>
      </button>
    );
  }

  return (
    <IconButton
      icon={MdInfoOutline}
      className={className}
      onClick={handleClick}
      aria-label={t("このアプリについて")}
      {...rest}
    />
  );
};

export default InformationButton;
